var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-bubble',{attrs:{"isMine":_vm.isMine,"message":_vm.message}},[_c('video',{staticClass:"video",attrs:{"src":_vm.payload.videoUrl,"poster":_vm.payload.thumbUrl,"controls":""},on:{"error":_vm.videoError}})])}
var staticRenderFns = []

export { render, staticRenderFns }